import type { IconProps } from '.';

/**
 * Checkmark Circle Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const CheckmarkCircleIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 416 416"
    className={className}
  >
    <path
      transform="translate(-48 -48)"
      fill="#ff4712"
      d="M256,48c-114.7,0-208,93.3-208,208s93.3,208,208,208,208-93.3,208-208S370.7,48,256,48ZM364.2,186.3l-134.4,160c-3,3.6-7.4,5.6-12,5.7h-.3c-4.5,0-8.9-1.9-11.9-5.3l-57.6-64c-6.1-6.4-5.8-16.6.7-22.6,6.4-6.1,16.6-5.8,22.6.7.2.2.3.4.5.6l45.3,50.3,122.6-145.9c5.8-6.7,15.9-7.4,22.6-1.6,6.5,5.7,7.4,15.5,1.9,22.2Z"
    />
  </svg>
);

export default CheckmarkCircleIcon;
